module.exports = __webpack_public_path__ + "c2d85fb1cbd2f02384866230c06bf7a4.webp";